import { Injectable } from '@angular/core';  
import { MatDialog, MatDialogRef } from '@angular/material/dialog';  
import { SpinnerComponent } from './spinner.component';  

@Injectable() 
export class SpinnerService {

  constructor(private readonly dialog: MatDialog) { }

  start(): MatDialogRef<SpinnerComponent> {  
        
    const dialogRef = this.dialog.open(SpinnerComponent,{  
        disableClose: true  
    });  
    return dialogRef;  
  };  

stop(ref:MatDialogRef<SpinnerComponent>){  
    ref.close();  
}   
}
